import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import campaign from '@src/views/campaign/store/campaign';
import campaignList from '@src/views/campaignList/store/campaignList';
import cashHistory from '@src/views/cashHistory/store/cashHistory';
import companyInfo from '@src/views/company/store/companyInfo';
import companyManagers from '@src/views/company/store/managers';
import companyDetailModal from '@src/views/company/store/modal';
import companyProjects from '@src/views/company/store/projects';
import company from '@src/views/companyList/store/company';
import companySidebar from '@src/views/companyList/store/companySidebar';
import couponsList from '@src/views/couponList/store/couponList';
import guideDetail from '@src/views/guide/store/guideDetail';
import guideList from '@src/views/guideList/store/guideList';
import issuedCouponList from '@src/views/issuedCouponList/store/issuedCouponList';
import login from '@src/views/login/store/login';
import orderHistory from '@src/views/orderHistory/store/orderHistory';
import adminList from '@src/views/project/store/adminList';
import influencerMatching from '@src/views/project/store/influencerMatching';
import project from '@src/views/project/store/project';
import projectList from '@src/views/projectList/store/projectList';
import promotionList from '@src/views/promotionList/store/promotionList';
import user from '@src/views/user/store/user';
import userList from '@src/views/userList/store/userList';
import userSidebar from '@src/views/userList/store/userSidebar';
import layout from './layout';
import navbar from './navbar';

const rootReducer = {
  navbar,
  layout,
  login,
  userList,
  userSidebar,
  user,
  company,
  companySidebar,
  companyInfo,
  companyProjects,
  companyManagers,
  project,
  companyDetailModal,
  orderHistory,
  cashHistory,
  couponsList,
  issuedCouponList,
  promotionList,
  guideList,
  projectList,
  guideDetail,
  influencerMatching,
  adminList,
  campaignList,
  campaign,
};

const persistConfig = {
  key: 'v.1.7',
  storage,
  whitelist: ['layout'],
};

export default persistReducer(persistConfig, combineReducers(rootReducer));
